<template>
    <wizard-layout :id="this.step">
        <template>
            <wizard-box-left>

                <wizard-step :step="this.step" :header_step="this.header_step" :user="this.user"></wizard-step>
                <wizard-header :title="this.title"></wizard-header>

                <div class="row">
                    <div class="col-12">
                        <vue-dropzone ref="myVueDropzone"
                                      id="dropzone"
                                      :options="dropZoneOptions"
                                      @vdropzone-file-added="fileAdded"
                                      @vdropzone-removed-file="removeThisFile"
                        >
                        </vue-dropzone>
                    </div>

                    <div class="col-12 d-flex justify-content-start mt-4 mb-1">
                        <small>Formati supportati: .png, .jpg, .jpeg, .pdf </small>
                    </div>

                    <div class="col-12 d-flex justify-content-start">
                        <small>Dimensione massima: 5MB </small>
                    </div>
                </div>

                <wizard-footer :step="this.step"
                               :display_next_button="display_next_button"
                               :wizard_data="getWizardData"
                               :user="this.user"
                >
                </wizard-footer>

            </wizard-box-left>
            <wizard-box-right :id="this.step">
                <wizard-progress :progress="this.progress" :progress_title="this.progress_title" :progress_description="this.progress_description"></wizard-progress>

            </wizard-box-right>
        </template>
    </wizard-layout>
</template>


<script>

import WizardLayout from "@/Pages/Wizard/Layouts/WizardLayout";
import WizardBoxRight from "@/Pages/Wizard/Layouts/WizardBoxRight";
import WizardBoxLeft from "@/Pages/Wizard/Layouts/WizardBoxLeft";
import WizardStep from "@/Pages/Wizard/Elements/WizardStep";
import WizardHeader from "@/Pages/Wizard/Elements/WizardHeader";
import WizardFooter from "@/Pages/Wizard/Elements/WizardFooter";
import WizardProgress from "@/Pages/Wizard/Elements/WizardProgress";
import Button from "@/Jetstream/Button";
import vueDropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import {redirectWizardSteps} from "@/helpers/helper";

export default {
    props: ['data', 'user'],

    computed: {
        display_next_button() {
            return this.fieldsAreEmpty()
        },

        getWizardData() {
            return {
                files: this.files
            }
        }
    },

    components: {
        Button,
        WizardProgress,
        WizardFooter, WizardHeader, WizardStep, WizardBoxLeft, WizardLayout, WizardBoxRight, vueDropzone
    },

    data() {
        return {
            step: 5,
            header_step: 6,
            title: "La piantina e le foto del tuo immobile",
            progress: 3,
            progress_title: "Inviaci piantina e foto del tuo immobile.",
            progress_description: "Trascina e/o allega qui la planimetria e le foto del tuo immobile. Non importa che siano foto professionali, quello di cui hanno bisogno i nostri professionisti è di vedere lo stato in cui si trova.",
            dropZoneOptions: {
                url: '/wizard/customer/post/step/5',
                autoProcessQueue: false,
                maxFilesize: 5,
                addRemoveLinks: true,
                dictRemoveFile: "Rimuovi",
                dictDefaultMessage: "Trascina qui i tuoi file oppure scegli file",
            },
            allowed_files: [
                "pdf",
                "jpeg",
                "png",
                "jpg",
            ],
            files: []
        }
    },

    methods: {
        isAgency() {
            return (this.user !== null && !(window.location.href.includes('customer')))
        },

        fieldsAreEmpty() {
            return true
        },

        fileAdded(file) {
            let file_extension = file.file_name ? file.file_name.split('.') : file.name.split('.')

            if (this.allowed_files.includes(file_extension[file_extension.length - 1])) {
                this.files.push(file)
            } else {
                this.$refs.myVueDropzone.removeFile(file)
            }
        },

        removeThisFile(file, error, xhr){
            this.files = this.files.filter(filee => {
                return filee !== file
            })
        }
    },

    mounted() {
        let current_property_id = localStorage.getItem('current_property_id')
        axios.get('/wizard/properties/' + current_property_id + '/images')
            .then(response => {
                let images = response.data.files

                if (images.length > 0) {
                    images.forEach(image => {
                        let file = image
                        let url = '/storage/' + image.id + '/' + image.file_name
                        this.$refs.myVueDropzone.manuallyAddFile(file, url)
                    })
                }
            })
            .catch(error => {
                console.log(error)
            })
    },

    beforeMount() {
        redirectWizardSteps(this.isAgency(),this.step,'test',this.$inertia)
    }
}
</script>
